import { Client } from '@viddsee/server-api-client';
import { baseConfiguration } from './webcall-base';

export const searchApi = new Client.SearchApi(baseConfiguration);
